import {Component, Input, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AbstractBaseDetailsComponent} from '../../../core/component/abstract-base-details-component';
import {FunnelHistory} from '../../../modules/funnel/modal/funnel-history';
import {FunnelServiceService} from '../../../modules/funnel/service/funnel-service.service';
import {CommonSelectListService} from '../../service/common-select-list.service';


@Component({
  selector: 'app-funnel-history',
  templateUrl: './funnel-history.component.html',
  styleUrls: ['./funnel-history.component.css']
})
export class FunnelHistoryComponent extends AbstractBaseDetailsComponent implements OnInit {
  public data: Array<FunnelHistory>;
  @Input() funnelID: number;
  constructor(
      private service: FunnelServiceService,
      public toaster: ToastrService,
      public commonService: CommonSelectListService,
      private router: Router
  ) {
    super(toaster);
  }

  ngOnInit() {
    this.getFunnelHistory();
  }

  public getFunnelHistory() {
    this.service.getFunnelHistory().subscribe((response) => {
      this.validateResponse(response, () => {
        this.data = new Array<FunnelHistory>();
        this.data = response.dataList.filter((items) => items.funnel === this.funnelID);
      });
    });
  }
}
